var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-view"},[(_vm.iframeUrl)?_c('iframe',{attrs:{"src":_vm.iframeUrl,"frameborder":"0"}}):(_vm.pdfUrl)?_c('PdfView',{attrs:{"url":_vm.pdfUrl}}):_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }